const QueryParams = require('../../../../page/frontend/helpers/params');

module.exports = class DealFetcher {
  constructor(domConfig) {
    const { csrfToken, isGoodsPage } = domConfig;
    this.csrfToken = csrfToken;
    this.isGoodsPage = isGoodsPage;
    this.cachedPaginatedCards = {};
  }

  fetchLazyLoadedCards() {
    const paramObject = Groupon.Utils.unparam();
    paramObject['_csrf'] = this.csrfToken;

    const queryParamsString = QueryParams.toString(paramObject);
    const url = `/partial${this.getPath()}/get-lazy-loaded-cards?${queryParamsString}`;

    return fetch(url, { credentials: 'include' })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        return Promise.resolve(data);
      });
  }

  fetchCards(paramObject) {
    paramObject['_csrf'] = this.csrfToken;

    const queryParamsString = QueryParams.toString(paramObject);
    const url = `/partial${this.getPath()}/get-paginated-cards?${queryParamsString}`;

    return fetch(url, { credentials: 'include' })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        return Promise.resolve(data);
      });
  }

  fetchFacets() {
    const paramObject = Groupon.Utils.unparam();
    paramObject['_csrf'] = this.csrfToken;

    const queryParamsString = QueryParams.toString(paramObject);
    const url = `/partial${this.getPath()}/get-page-header-and-facets?${queryParamsString}`;

    return fetch(url, { credentials: 'include' })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        return Promise.resolve(data);
      });
  }

  fetchBottomContent() {
    const paramObject = Groupon.Utils.unparam();
    paramObject['_csrf'] = this.csrfToken;

    const url = `/partial${this.getPath()}/get-bottom-content?${QueryParams.toString(
      paramObject
    )}`;

    return fetch(url, { credentials: 'include' })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        return Promise.resolve(data);
      });
  }

  getPath() {
    if (this.isGoodsPage) {
      const { pathname } = window.location;
      return pathname.replace(/\/$/, '');
    }
    return '/browse';
  }
};
